/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { IdentityContextConsumerAsObserver } from "abreact/core/identity/IdentityContextComponents";
import { component_identity, IdentityContext, IdentityUtils } from "abreact/core/identity/IdentityUtils";
import { PageStateLogger } from "abreact/core/pagestate/PageStateLogger";
import { PageStateStorageIdentityContext, PageStateTools } from "abreact/core/pagestate/PageStateTools";
import React from "react";
/**
 * Ensures that the final emitted content is wrapped correctly with the necessary contexts and
 * handles mobx observability correctly.
 */
export class RenderWithPageState extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      useMobx,
      component
    } = this.props;
    PageStateLogger.maybeLogFor("system", component, `render from RenderWithPageState for ${IdentityUtils.getBestAvailableIdentifierForComponent(component)}`);
    return /*#__PURE__*/React.createElement(PageStateStorageIdentityContext.Consumer, null, pageStateStorageIdentity => useMobx ? this.renderAsObserver(pageStateStorageIdentity) : this.renderAsNonObserver(pageStateStorageIdentity));
  }
  renderAsObserver(pageStateStorageIdentity) {
    /*
    This is a CRITICAL aspect of how this works. This consumer becomes the reaction target
    for mobx dependencies, which works because after the first invocation, the component
    has been initialized with everything it needs.
    */
    return /*#__PURE__*/React.createElement(IdentityContextConsumerAsObserver, {
      component: this.props.component,
      renderContent: parentIdentityContext => this.handleRenderContent(pageStateStorageIdentity, parentIdentityContext)
    });
  }
  renderAsNonObserver(pageStateStorageIdentity) {
    return /*#__PURE__*/React.createElement(IdentityContext.Consumer, null, parentIdentityContext => this.handleRenderContent(pageStateStorageIdentity, parentIdentityContext));
  }
  handleRenderContent(pageStateStorageIdentity, parentIdentityContext) {
    if (parentIdentityContext?.componentIdentity != null) {
      const identity = this.initializeComponentIfNecessaryAndGetIdentity(parentIdentityContext.componentIdentity, pageStateStorageIdentity);
      return /*#__PURE__*/React.createElement(IdentityContext.Provider, {
        value: {
          componentIdentity: identity
        }
      }, this.props.renderContent());
    } else {
      return this.props.renderContent();
    }
  }
  initializeComponentIfNecessaryAndGetIdentity(parentIdentity, pageStateStorageIdentity) {
    const identifiableComponent = IdentityUtils.convertToIdentifiable(this.props.component);
    if (!identifiableComponent[component_identity].qualifiedId) {
      IdentityUtils.initializeIdentity(identifiableComponent, parentIdentity);
      PageStateTools.initializePageStateStorageForRender(identifiableComponent, pageStateStorageIdentity);
    }
    return IdentityUtils.getComponentIdentity(identifiableComponent);
  }
}
//# sourceMappingURL=RenderWithPageState.js.map
